<template>
  <!-- 单品方案设计 -->
  <div class="addSpellGroup"><!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="width: 100%;height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="right"
        label-width="200px" :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="addForm.name" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动商品" prop="goodsId">
            <el-input readonly v-model="addForm.goodsName" style="width:200px;" @click.native="setTableData('goods')" placeholder="单击选择"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动开始时间" prop="startTime">
            <el-date-picker
              v-model="addForm.startTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:200px;"
              placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动结束时间" prop="endTime">
            <el-date-picker
              v-model="addForm.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:200px;"
              placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="成团人数" prop="num">
            <el-input-number v-model="addForm.num" :min="1"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="拼团持续时间" prop="time">
            <el-input-number v-model="addForm.time" :min="0"
              style="width:200px;"></el-input-number>
            <span>（小时）</span>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="最小商品购买数量" prop="minGoodsNum">
            <el-input-number v-model="addForm.minGoodsNum" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="最大商品购买数量" prop="maxGoodsNum">
            <el-input-number v-model="addForm.maxGoodsNum" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="参与拼团商品数量" prop="goodsNum">
            <el-input-number v-model="addForm.goodsNum" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="活动拼团上限(0无限制)" prop="maxGroupNum">
            <el-input-number v-model="addForm.maxGroupNum" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="活动单价" prop="price">
            <el-input-number v-model="addForm.price" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="userType">
            <el-checkbox v-model="userTypeAll" @change="getUserTypeAll">全选</el-checkbox>
            <el-checkbox-group v-model="addForm.userType" @change="setUserTypeAll" style="width: 1000px">
              <el-checkbox
                v-for="item in userTypeList"
                :key="item.value"
                :label="item.value">
                {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="条件不满足时是否开启" prop="isNoSatisfy" class="el-form-required-true">
            <el-select v-model="addForm.isNoSatisfy" style="width:200px;margin-right:5px">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="备注" prop="des">
            <el-input v-model="addForm.des" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="区域控销" prop="limitArea">
            <el-select v-model="addForm.limitArea" placeholder="区域控销" 
              style="width:200px;margin-right:5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="addForm.limitArea != 0">
          <el-form-item label="选择区域" prop="areaValue" class="el-form-required-true">
            <div style="width: 800px;">
              <div>
                <el-tag 
                  v-for="(item,index) in areaList" 
                  :key="index" 
                  closable
                  @close="tagClose(index,'areaValue','areaList')"
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px;">{{item.label}}
                </el-tag>
              </div>
              <el-button type="primary" @click="setTableData('area')">增加区域</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户控销" prop="limitUser">
            <el-select v-model="addForm.limitUser" placeholder="客户控销" 
              style="width:200px;margin-right:5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="addForm.limitUser != 0">
          <el-form-item label="选择客户" prop="userValue" class="el-form-required-true">
            <div style="width: 800px;">
              <div>
                <el-tag 
                  v-for="(item,index) in userList" 
                  :key="index" 
                  closable
                  @close="tagClose(index,'userValue','userList')"
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px;">{{item.label}}
                </el-tag>
              </div>
              <el-button type="primary" @click="setTableData('user')">增加客户</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>

    <!-- 数据选择 -->
    <tableDialog 
      v-if="dialogVisible"
      :title="tableData.title"
      :isMoreSel="tableData.isAllSel"
      :searchValue="searchForm.name"
      :tableData="tableList"
      :tableHead="tableDataHead"
      :currPage.sync="currPage"
      :allPage="allPage"
      @search="getTableData"
      @moreSel="selDataOk"
      @rowClick="rowClick"
      @hanCurrChange="hanCurrChange"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'addSpellGroup',
  data() {
    return {
      id: '',
      /**新增表单 */
      addForm:{
        entId: "",// 机构ID
        name: "", // 活动名称
        goodsId: "", // 活动商品
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        num: "", // 拼团人数
        time: "", // 拼团持续时间
        minGoodsNum: "", // 最小商品购买数量
        maxGoodsNum: "", // 最大商品购买数量
        goodsNum: "", // 参与拼团商品数量
        maxGroupNum: "", // 拼团上限
        price: "", // 活动单价
        userType: [], // 客户类型
        isNoSatisfy: "1", // 条件不满足时是否开启
        des: "", // 备注
        limitArea: "0", // 区域控销
        areaValue: "", // 选择区域
        limitUser: "0", // 客户控销
        userValue: "", // 选择客户
      },
      /**表单规则 */
      addFormRule:{
        name: [mustFill], // 活动名称
        goodsId: [mustFill], // 活动商品
        startTime: [mustFill], // 开始时间
        endTime: [mustFill], // 结束时间
        num: [mustFill], // 拼团人数
        time: [mustFill], // 拼团持续时间
        minGoodsNum: [mustFill], // 最小商品购买数量
        maxGoodsNum: [mustFill], // 最大商品购买数量
        goodsNum: [mustFill], // 参与拼团商品数量
        maxGroupNum: [mustFill], // 拼团上限
        price: [mustFill], // 活动单价
        userType: [mustFill], // 客户类型
        isNoSatisfy: [mustFill], // 条件不满足时是否开启
        limitArea: [mustFill], // 区域控销
        areaValue: [this.limitFill('limitArea')], // 选择区域
        limitUser: [mustFill], // 客户控销
        userValue: [this.limitFill('limitUser')], // 选择客户
      },
      userTypeList: [],
      userTypeAll: false,
      areaList: [],
      userList: [],
      dialogVisible: false,
      currPage: 1,
      allPage: 0,
      // 表格多选时是否有已选的数据
      isSelDataOkRep: false,
      searchForm: {
        name: ''
      },
      tableData:{
        type: '',
        title: '',
        sqlType: '',
        key: '',
        isAllSel: false,
      },
      tableList: [],
      tableDataHead: {}
    }
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if(prams.id){
      this.id = prams.id
      this.getSpellGroup()
    }
    this.getUserType()
  },
  computed: {
    entId() {
      return this.addForm.entId;
    }
  },
  methods:{
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    // 获取集采活动详情
    getSpellGroup(){
      let data = {
        type: "GetptpeizhiById",
        fabh: this.id
      };
      let proc = "Proc_Admin_pintuan";//存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method:"post",
        url: "prom/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then((res) => {
        console.log(res);
        if (res.flag == 0) {
          let data = res.data[0]
          this.addForm.entId = data.entId
          this.addForm.name = data.ptname
          this.addForm.goodsId = data.article_id
          this.addForm.goodsName = data.sub_title
          this.addForm.startTime = new Date(data.startTime)
          this.addForm.endTime = new Date(data.endTime)
          this.addForm.num = data.population
          this.addForm.time = data.continued_time
          this.addForm.minGoodsNum = data.clientMinNum
          this.addForm.maxGoodsNum = data.clientMaxNum
          this.addForm.goodsNum = data.maxGoodsNum
          this.addForm.maxGroupNum = data.maxGroupNum
          this.addForm.price = data.group_price
          this.addForm.userType = this.$changeStrArr(data.customertype)
          this.setUserTypeAll()
          this.addForm.isRobot = data.isSuccess
          this.addForm.des = data.remarks
          this.addForm.limitArea = data.kx_quyu.trim() || '0'
          this.addForm.areaValue = this.$changeStr(data.quyu_id_list)
          this.addForm.limitUser = data.kx_kehu.trim() || '0'
          this.addForm.userValue = this.$changeStr(data.kehu_id_list)

          let valueList = this.$changeStrArr(data.quyu_id_list)
          let labelList = this.$changeStrArr(data.quyu_name_list)
          this.areaList = valueList.map((item,index) => ({label: labelList[index],value: valueList[index]}))
          valueList = this.$changeStrArr(data.kehu_id_list)
          labelList = this.$changeStrArr(data.kehu_name_list)
          this.userList = valueList.map((item,index) => ({label: labelList[index],value: valueList[index]}))
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    // 获取客户类型
    getUserType(){
      let proc = "Proc_Admin_CustomerList";//存储过程名
      let type = "ReturnList";
      let json = {
        type: "CustomType"
      };
      this.$requestSys({
        method:"post",
        url: "coupon/ashx/returnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(json)) + "&proc=" + proc,
        dataType:"json"
      }).then((res) => {
        if (res.flag == 0) {
          this.userTypeList = res.data.map(item => ({label: item.clienttype,value: item.TypeID}))
          this.setUserTypeAll()
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    // 设置全选
    setUserTypeAll(){
      this.userTypeAll = this.userTypeList.length == this.addForm.userType.length
    },
    getUserTypeAll(value){
      if(value){
        this.addForm.userType = this.userTypeList.map(item => item.value)
      }else{
        this.addForm.userType = []
      }
    },
    // 设置弹框请求数据
    setTableData(type){
      if(type == 'goods'){
        this.tableData.title = '商品列表'
        this.tableData.sqlType = 'GoodsList'
        this.tableData.key = 'sub_title'
        this.tableData.isAllSel = false
      }else if(type == 'area'){
        this.tableData.title = '区域列表'
        this.tableData.sqlType = 'RegionList'
        this.tableData.key = '地址'
        this.tableData.isAllSel = true
      }else if(type == 'user'){
        this.tableData.title = '用户列表'
        this.tableData.sqlType = 'CompanyList'
        this.tableData.key = '单位名称'
        this.tableData.isAllSel = true
      }
      this.tableData.type = type
      this.getTableData()
    },
    // 获取弹出框表格数据
    getTableData(val,isRep){
      this.searchForm.name = isRep ? val : this.searchForm.name
      let data = {
        type: this.tableData.sqlType,
        PageIndex: this.currPage,
        PageSize: 10,
        strWhere: this.searchForm.name,
      };
      let proc = "Proc_Admin_SearchInfo";//存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method:"post",
        url: "ashx/MainReturnJson.ashx?json=" + encodeURIComponent(JSON.stringify(data)) + "&type=" + type + "&proc=" + proc,
      }).then((res) => {
        if (res.flag == 0) {
          this.tableList = res.content
          this.tableDataHead = res.fdname
          this.allPage = res.recordCount
          this.dialogVisible = true
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
    // 选择单条数据
    rowClick(row,isSelDataOk){
      if(this.tableData.type == 'goods'){
        console.log(row);
        this.addForm.goodsId = row.keyid
        this.addForm.entId = row.entId
        this.addForm.goodsName = row[this.tableData.key]
      }else if(this.tableData.type == 'area' || this.tableData.type == 'user'){
        for(let i = 0; i < this[this.tableData.type + 'List'].length; i++){
          if(this[this.tableData.type + 'List'][i].value == row.keyid){
            if(isSelDataOk === true){
              this.isSelDataOkRep = true
            }else{
              this.$message({
                message: '选择的数据已在列表中',
                type: 'warning'
              });
            }
            return
          }
        }
        this[this.tableData.type + 'List'].push({
          label: row[this.tableData.key],
          value: row.keyid
        })
        this.addForm[this.tableData.type + 'Value'] = this[this.tableData.type + 'List'].map(item => item.value).join()
      }
      this.dialogVisible = false
    },
    // 选择数据完成，多选
    selDataOk(selectedList){
      if(selectedList.length == 0){
        this.$message({
          message: '请选择数据',
          type: 'warning'
        });
        return
      }
      selectedList.forEach(item => {
        this.rowClick(item,true)
      })
      if(this.isSelDataOkRep){
        this.$message({
          message: '选择的数据已在列表中',
          type: 'warning'
        });
        this.isSelDataOkRep = false
      }
    },
    // 标签删除
    tagClose(index,key,keyList){
      this[keyList].splice(index,1)
      this.addForm[key] = this[keyList].map(item => item.value).join()
    },
    // 控销控制验证
    limitFill(key){
      return {validator:(rule, value, callback) => {
        if(this.addForm[key] != 0){
          if(!value){
            return callback(new Error('该字段为必填项'))
          }else{
            return callback()
          }
        }else{
          return callback()
        }
      }}
    },
    /**提交表单 */
    submit(){
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          let data = {
            // EntId: this.entId, 
            Fabh: this.id, // 拼团ID
            EntId: this.addForm.entId,//商品机构ID
            Ptname: this.addForm.name, // 拼团名称
            Article_Id: this.addForm.goodsId, // 商品ID
            startTime: this.$formatDate(this.addForm.startTime,true), // 拼团开始时间
            endTime: this.$formatDate(this.addForm.endTime,true), // 拼团结束时间
            Group_Price: this.addForm.price, // 活动单价
            Population: this.addForm.num, // 成团人数
            Continued_Time: this.addForm.time, // 拼团持续时间
            clientMinNum: this.addForm.minGoodsNum, // 最小商品购买数量
            clientMaxNum: this.addForm.maxGoodsNum, // 最大商品购买数量
            maxGoodsNum: this.addForm.goodsNum, // 参与拼团商品数量
            maxGroupNum: this.addForm.maxGroupNum || 0, // 拼团上限
            isSuccess: this.addForm.isNoSatisfy, // 条件不满足时是否开启
            customertype: this.addForm.userType.join(','), // 客户类型
            Remarks: this.addForm.des, // 备注
            kx_quyu : this.addForm.limitArea,
            quyu_id_list: this.addForm.areaValue,
            quyu_name_list: this.areaList.map(item => item.label).join(','),
            kx_kehu: this.addForm.limitUser,
            kehu_id_list: this.addForm.userValue,
            kehu_name_list: this.userList.map(item => item.label).join(','),
          };
          this.$request({
            method:"post",
            url: 'PinTuan/SaveSpellGroup',
            data: data
          }).then((res) => {
            if(res.success){
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.goBack()
            }else{
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err)
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.addSpellGroup{
  width: 100%;
  height: 100%;
}
.payTips{
  font-size: 14px;
  color: #F56C6C;
}
</style>
